import { FILTER } from "@/constants";
import CheckboxSelect from "@/containers/Filters/CheckboxSelect";
import FilterCountIndicator from "@/containers/Filters/FilterCountIndicator";
import { FilterOption } from "@/types/FilterOptions";
import { Accordion } from "@components/Accordion";

import useFilterCount from "../../hooks/useFilterCount";
import useOptionLabel from "../../hooks/useOptionLabel";

export type ChannelTypeProps = {
  options: FilterOption[];
};

const ChannelType: React.FunctionComponent<ChannelTypeProps> = ({
  options,
}) => {
  const preview = useOptionLabel(FILTER.CHANNEL_TYPE, options);
  const count = useFilterCount(FILTER.CHANNEL_TYPE);

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <Accordion
      value="channel-type"
      data-testid="filter-bar--channel-type"
      preview={preview}
      indicator={<FilterCountIndicator count={count} />}
      title={L.MENTIONS_VIEW_TOOLBAR_FILTER_CHANNEL_TYPE_LABEL}
    >
      <CheckboxSelect name={FILTER.CHANNEL_TYPE} options={options} />
    </Accordion>
  );
};

export default ChannelType;
